import {Component, Input, OnInit} from "@angular/core";
import {Action, ActionResult } from "@appkitjs.com/types";
import { isValid, parseISO } from "date-fns";
import { Strings } from "src/app/text/strings";
import { parse } from "uri-js";
import log from 'loglevel';

@Component({
  templateUrl: './assignment-editor.app.html',
  styleUrls: ['./assignment-editor.app.scss']
})
export class AssignmentEditorApp {

  initialized = false;
  _action?: Action;
  entityId?: string;
  _cancelable = false;
  accountId?: string;
  date?: Date;

  get cancelable(): boolean {
    return this._cancelable;
  }

  get action(): Action {
    return this._action!;
  }

  @Input()
  set action(value: Action) {
    log.debug('Updates action: ', value);
    this._action = value;
    if (value != null) {
      const uri = parse(value.data.uri);
      if(uri.host === 'assignments' && uri.path != '') {
        this.entityId = uri.path;
      }

      if(uri.query != null) {
        const query = Strings.parseQueryString(uri.query);
        this._cancelable = query.cancelable == 'true';
        this.accountId = query.accountId;

        try {
          const tempDate = query.date != null ? parseISO(query.date): undefined;
          this.date = isValid(tempDate) ? tempDate : undefined;
        } catch(error) {
          console.error('Unable to parse date as ISO date.');
        }
      }
    }
  }

  onSaved() {
    log.debug('OnSaved');
    if(this._action != null) {
      this._action.finish!(ActionResult.Ok);
    }
  }

  onCanceled() {
    log.debug('OnCanceled');
    if(this._action != null) {
      this._action!.finish!(ActionResult.Canceled); 
    }  
  }

}
